
var sprite = require("/home/romain/Cozy/cozy-proxy/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20\" id=\"icon-eye-open_c8058f61e5bdb7f049345595cf0c244a\" > <path fill=\"#788195\" fill-rule=\"evenodd\" d=\"M21,10 C21,10 24,4 30,4 C36,4 39,10 39,10 C39,10 36,16 30,16 C24,16 21,10 21,10 Z M30,14 C32.2091391,14 34,12.2091391 34,10 C34,7.79086089 32.2091391,6 30,6 C27.7908609,6 26,7.79086089 26,10 C26,12.2091391 27.7908609,14 30,14 Z M30,12 C31.1045696,12 32,11.1045696 32,10 C32,8.89543045 31.1045696,8 30,8 C28.8954304,8 28,8.89543045 28,10 C28,11.1045696 28.8954304,12 30,12 Z\" transform=\"translate(-20)\"/> </symbol>";
module.exports = sprite.add(image, "icon-eye-open_c8058f61e5bdb7f049345595cf0c244a");


//////////////////
// WEBPACK FOOTER
// ./app/assets/sprites/icon-eye-open.svg
// module id = 93
// module chunks = 0